export type IDrofusOccurrenceValidationColorScope =
  | { type: "overall" }
  | { type: "listType"; value: string }
  | { type: "responsibility"; value: string };

const PREFIX = "specifiedArticles";
const LIST_TYPE_PREFIX = `${PREFIX}.listType:`;
const RESPONSIBILITY_PREFIX = `${PREFIX}.responsibility:`;

const encodeScopeValue = (value: string) => encodeURIComponent(value.trim());
const decodeScopeValue = (value: string) => decodeURIComponent(value);

export const DROFUS_OCCURRENCE_VALIDATION_OVERALL_ID = `${PREFIX}.overall`;

export const makeDrofusOccurrenceValidationListTypeColoringId = (listType: string) =>
  `${LIST_TYPE_PREFIX}${encodeScopeValue(listType)}`;

export const makeDrofusOccurrenceValidationResponsibilityColoringId = (
  responsibility: string
) => `${RESPONSIBILITY_PREFIX}${encodeScopeValue(responsibility)}`;

export const parseDrofusOccurrenceValidationColoringId = (
  id: string | undefined | null
): IDrofusOccurrenceValidationColorScope | null => {
  if (!id?.startsWith(`${PREFIX}.`)) return null;
  if (id === DROFUS_OCCURRENCE_VALIDATION_OVERALL_ID) return { type: "overall" };

  if (id.startsWith(LIST_TYPE_PREFIX)) {
    const value = decodeScopeValue(id.slice(LIST_TYPE_PREFIX.length)).trim();
    return value ? { type: "listType", value } : null;
  }

  if (id.startsWith(RESPONSIBILITY_PREFIX)) {
    const value = decodeScopeValue(id.slice(RESPONSIBILITY_PREFIX.length)).trim();
    return value ? { type: "responsibility", value } : null;
  }

  const legacyResponsibility = id.slice(`${PREFIX}.`.length).trim();
  return legacyResponsibility ? { type: "responsibility", value: legacyResponsibility } : null;
};

export const titleForDrofusOccurrenceValidationColoringId = (id: string): string => {
  const parsed = parseDrofusOccurrenceValidationColoringId(id);
  if (!parsed || parsed.type === "overall") return "Forekomstvalidering - samlet";
  if (parsed.type === "listType") return `Forekomstvalidering - ${parsed.value}`;
  return `Forekomstvalidering - ansvar ${parsed.value}`;
};
